/**
 * Canadian-style cookie notice — PIPEDA meaningful consent for optional analytics.
 * Essential site operation continues either way; GA / Meta Pixel load only after "Accept all".
 */

import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import {
  getCookieConsent,
  hasOptionalTrackingConfigured,
  setCookieConsent,
} from '../lib/cookieConsent';

export default function CookieConsentBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(getCookieConsent() === null);
  }, []);

  if (!visible) return null;

  const trackingConfigured = hasOptionalTrackingConfigured();

  const acceptAll = () => {
    setCookieConsent('analytics');
    setVisible(false);
  };

  const essentialOnly = () => {
    setCookieConsent('essential');
    setVisible(false);
  };

  return (
    <div
      className="fixed bottom-0 inset-x-0 z-[60] p-4 pointer-events-none"
      role="dialog"
      aria-labelledby="cookie-consent-title"
      aria-describedby="cookie-consent-desc"
    >
      <div className="mx-auto max-w-3xl pointer-events-auto rounded-xl border border-gray-200 bg-white shadow-2xl p-4 sm:p-5">
        <h2 id="cookie-consent-title" className="text-sm font-semibold text-gray-900">
          Your privacy
        </h2>
        <p id="cookie-consent-desc" className="mt-2 text-sm text-gray-600 leading-relaxed">
          Nanny B&apos;s Bakery respects your privacy under Canadian law (PIPEDA). We use essential
          storage so the site works (for example, remembering a promo you closed this visit).
          {trackingConfigured
            ? ' With your permission we also use analytics cookies to understand how visitors use our website.'
            : ' We do not use advertising or analytics cookies unless they are enabled later — you can read more in our Privacy Policy.'}{' '}
          <Link to="/privacy" className="text-primary-700 font-medium hover:underline">
            Privacy Policy
          </Link>
        </p>
        <div className="mt-4 flex flex-col sm:flex-row gap-2 sm:justify-end">
          <button
            type="button"
            onClick={essentialOnly}
            className="px-4 py-2.5 rounded-lg border border-gray-300 text-sm font-medium text-gray-700 hover:bg-gray-50"
          >
            Essential only
          </button>
          {trackingConfigured && (
            <button
              type="button"
              onClick={acceptAll}
              className="px-4 py-2.5 rounded-lg bg-primary-600 text-white text-sm font-medium hover:bg-primary-700"
            >
              Accept all
            </button>
          )}
          {!trackingConfigured && (
            <button
              type="button"
              onClick={essentialOnly}
              className="px-4 py-2.5 rounded-lg bg-primary-600 text-white text-sm font-medium hover:bg-primary-700"
            >
              Got it
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
